import React from "react"
import * as styles from "./refinBlock.module.scss"
import { FirstImg, SecondImg, ThirdImg } from "./img"

export const RefinBlockItems = [
  {
    titleItemBlock: (
      <h3>
        Рефинансируйте <br /> до{"\u00A0"}300{"\u00A0"}000₽
      </h3>
    ),
    descriptionItemBlock: (
      <p>
        Объедините долги в одну карту Халва и{"\u00A0"}вносите платёж раз в{"\u00A0"}месяц
      </p>
    ),
    imgItemBlock: <FirstImg alt="300k" className={styles.firstImg} />,
  },
  {
    titleItemBlock: (
      <h3>
        Рассрочка <br />
        до 24 месяцев
      </h3>
    ),
    descriptionItemBlock: <p>Экономьте на выплатах с{"\u00A0"}комфортным ежемесячным платежом</p>,
    imgItemBlock: <SecondImg alt="24 months" className={styles.secondImg} />,
  },
  {
    titleItemBlock: (
      <h3>
        Одобрение{"\u00A0"}в{"\u00A0"}день
        <br /> обращения
      </h3>
    ),
    descriptionItemBlock: (
      <p>
        Нужен только паспорт. <br className={styles.onlyTableAndMob} /> Быстро{"\u00A0"}и{"\u00A0"}
        без лишних документов
      </p>
    ),
    imgItemBlock: <ThirdImg alt="1 day" className={styles.thirdImg} />,
  },
]
